import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=544ef104&scoped=true&"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js&"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderComponent.vue?vue&type=style&index=0&id=544ef104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ef104",
  null
  
)

export default component.exports